<grt-tree-visualizer *ngIf="xml" [display]="treeDisplay" [sentence]="sentence || 'Unknown sentence'" [xml]="xml" (displayChange)="treeDisplay = $event"></grt-tree-visualizer>
<div *ngIf="!xml">No or invalid XML.</div>
